<section class="profile-page">
  <div class="page-heading">
    <div>
      <p>Account</p>
      <h1>My Profile</h1>
      <span>View your personal and account information.</span>
    </div>
    <a routerLink="/change-password">Change Password</a>
  </div>

  @if (user) {
    <div class="profile-card">
      <div class="identity">
        <div class="avatar">
          @if (user.profile_image) {
            <img [src]="user.profile_image" [alt]="user.full_name">
          } @else {
            <span>{{ profileInitials }}</span>
          }
        </div>
        <div>
          <h2>{{ user.full_name }}</h2>
          <p>{{ user.email }}</p>
          <div class="badges">
            <span>{{ user.role?.name || 'User' }}</span>
            <span [class.inactive]="!user.account_active">
              {{ user.account_active ? 'Active account' : 'Inactive account' }}
            </span>
          </div>
        </div>
      </div>

      <div class="details">
        <div class="detail-group">
          <div class="detail-group__heading">
            <h3>Personal information</h3>
            <p>Your contact details stored with this account.</p>
          </div>
          <dl>
            <div>
              <dt>First name</dt>
              <dd>{{ user.name || '—' }}</dd>
            </div>
            <div>
              <dt>Last name</dt>
              <dd>{{ user.lastname || '—' }}</dd>
            </div>
            <div>
              <dt>Email address</dt>
              <dd>{{ user.email || '—' }}</dd>
            </div>
            <div>
              <dt>Mobile number</dt>
              <dd>{{ user.mobile || '—' }}</dd>
            </div>
          </dl>
        </div>

        <div class="detail-group">
          <div class="detail-group__heading">
            <h3>Account information</h3>
            <p>Your access category and recent activity.</p>
          </div>
          <dl>
            <div>
              <dt>Role</dt>
              <dd>{{ user.role?.name || '—' }}</dd>
            </div>
            <div>
              <dt>User category</dt>
              <dd>{{ user.user_category || '—' }}</dd>
            </div>
            <div>
              <dt>Last login</dt>
              <dd>{{ user.last_login ? (user.last_login | date: 'd MMM y, h:mm a') : '—' }}</dd>
            </div>
            <div>
              <dt>Member since</dt>
              <dd>{{ user.created_on ? (user.created_on | date: 'd MMMM y') : '—' }}</dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  } @else {
    <div class="empty-state">
      <h2>Profile unavailable</h2>
      <p>Your account information could not be loaded. Please sign in again.</p>
    </div>
  }
</section>
